import httpClient, { plainHttpClient } from 'src/libs/axios';
import { API_ROUTES } from "src/constants/routes";
import { DashboardItemList } from 'src/types/dashboard';

const getAll = (): Promise<DashboardItemList> => {
    return plainHttpClient.get(API_ROUTES.users_list)
}
const DashboardService = {
    getAll,
  };
  
export default DashboardService;
